import { isEmpty } from './helpers/is-empty';
import { isNumeric } from './helpers/is-numeric';
import { ValidatorFunction } from '../types/validator-function.type';

export const max: ValidatorFunction = (value: any, args: { max: number }) => {
  if (isEmpty(value) || isEmpty(args)) {
    return null;
  }

  const tempValue = +value;
  const tempMax = +args?.max;

  if (!isNumeric(tempValue) || !isNumeric(tempMax)) {
    return null;
  }

  return tempMax < tempValue ? { max: { max: args?.max, actual: value } } : null;
};
